const KEY = "1755-session-id";

function genUuid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getOrCreateSessionId() {
  if (typeof localStorage === "undefined") return null;
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = genUuid();
    localStorage.setItem(KEY, id);
  }
  return id;
}
